// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_b2-b";
export var colorBlue = "_b2-8";
export var colorDot = "_b2-0";
export var colorDotLarge = "_b2-2";
export var colorDotSmall = "_b2-1";
export var colorGreen = "_b2-7";
export var colorGrey = "_b2-3";
export var colorOrange = "_b2-5";
export var colorPink = "_b2-a";
export var colorPurple = "_b2-9";
export var colorRed = "_b2-4";
export var colorYellow = "_b2-6";